module.exports = __webpack_public_path__ + "static/media/Babar Aziz.aafaf224.jpg";